export function getUrlParams<T>(urlParams: URLSearchParams): T {
  const params: { [key: string]: string } = {};
  for (const [key, value] of urlParams.entries()) {
    params[key] = value;
  }

  return params as T;
}
